// Global dayjs configuration. Imported once, for its side effects, before the
// app renders (see index.tsx).
//
// Ant Design's date pickers and calendars derive their first-day-of-week from
// the active dayjs locale. dayjs's default `en` locale starts weeks on Sunday;
// V1 (and the react-multi-date-picker calendars in V2) start on Monday, so we
// force Monday here to keep every calendar in the app consistent.
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(updateLocale);

// weekStart: 1 === Monday.
dayjs.updateLocale('en', { weekStart: 1 });

export default dayjs;
